import React, { createContext, ReactNode, useContext } from 'react';

import {
  IBlogPost,
  IGlobalConfiguration,
  IGlobalConfigurationFields,
  IPage,
  IPageFields
} from '../../../types/contentful';

export enum envEnum {
  development = 'development',
  preview = 'preview',
  staging = 'stage',
  production = 'prod',
  percy = 'percy'
}

export type WebRegUrls = {
  [key in envEnum]?: string;
};

export interface PageFieldProps {
  page?: IPageFields;
  config?: IGlobalConfigurationFields;
  cookies?: any;
}

export interface PageProps {
  resolvedUrl?: string;
  pageData?: IPage;
  blogPostData?: IBlogPost;
  globalConfig?: IGlobalConfiguration;
  cookies?: any;
  base?: string;
  slug?: string;
}

export interface PageProvider extends PageProps {
  children?: ReactNode | ReactNode[];
}

export const PageContext = createContext<PageFieldProps>({});

export const usePageDataContext = () => useContext(PageContext);

export function PageDataProvider({
  globalConfig,
  pageData,
  cookies,
  children
}: PageProvider) {
  return (
    <PageContext.Provider
      value={{
        config: globalConfig?.fields,
        page: pageData?.fields,
        cookies
      }}
    >
      {children}
    </PageContext.Provider>
  );
}
